import { apiFetch } from '@/platform/lib/api';

export type RankingEntry = {
  claimId: string;
  ownerId: string;
  score: number;
  roiPct?: number;
  avgStars?: number;
};

export type RankingsDoc = {
  period: string;
  metric: string;
  minStars: number;
  entries: RankingEntry[];
  computedAt?: string;
};

export function getRankings(params?: { period?: string; metric?: string; minStars?: number }) {
  const q = new URLSearchParams();
  if (params?.period) q.set('period', params.period);
  if (params?.metric) q.set('metric', params.metric);
  if (params?.minStars != null) q.set('minStars', String(params.minStars));
  const qs = q.toString();
  return apiFetch<RankingsDoc>(`/rankings${qs ? `?${qs}` : ''}`);
}
